import { Boundary } from '@tcc/shared-data-lib';

export const getBoundaryCoordinates = (boundary: Boundary) => {
  switch (boundary.type) {
    case 'Polygon':
      return boundary.polygonCoordinates;
    case 'MultiPolygon':
      return boundary.multiPolygonCoordinates;
    case 'Point':
      return boundary.pointCoordinates;
    default:
      return null;
  }
};

export const parseBoundaryToGeoJson = (boundary?: Boundary) => {
  if (!boundary) {
    return null;
  }

  const coordinates = getBoundaryCoordinates(boundary);

  if (!coordinates) {
    return null;
  }

  return {
    type: 'FeatureCollection' as const,
    features: [
      {
        type: 'Feature' as const,
        properties: {},
        geometry: {
          type: boundary.type,
          coordinates,
        },
      },
    ],
  };
};
